module.exports = __webpack_public_path__ + "media/theme/tutorial__reco--6--create-69db7b52.png";